<h2 mat-dialog-title>Upload Result</h2>
<div mat-dialog-content class="dialog-content">
  <p>{{ data.message }}</p>

  <h5 *ngIf="data.errors && data.errors.length > 0" class="text-danger">Failed Records</h5>
  <div *ngIf="data.errors && data.errors.length > 0" class="table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>Student Info</th>
          <th>Error Reason</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let err of data.errors">
          <td>
            {{ err.row.FirstName }} {{ err.row.LastName }} <br />
            <small *ngIf="err.row.MobileNo">({{ err.row.MobileNo }})</small>
          </td>
          <td class="text-danger">{{ err.error }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h5 *ngIf="data.createdStudents && data.createdStudents.length > 0" class="text-success">Successfully Added</h5>
  <div *ngIf="data.createdStudents && data.createdStudents.length > 0" class="table-responsive mb-3">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>First Name</th>
          <th>Middle Name</th>
          <th>Last Name</th>
          <th>Mobile No</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let student of data.createdStudents">
          <td>{{ student.FirstName }}</td>
          <td>{{ student.MiddleName || "-" }}</td>
          <td>{{ student.LastName }}</td>
          <td>{{ student.MobileNo }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h5 *ngIf="data.existingStudents && data.existingStudents.length > 0" class="text-danger">Already Registered</h5>
  <div *ngIf="data.existingStudents && data.existingStudents.length > 0" class="table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>First Name</th>
          <th>Middle Name</th>
          <th>Last Name</th>
          <th>Mobile No</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let student of data.existingStudents">
          <td>{{ student.FirstName }}</td>
          <td>{{ student.MiddleName || "-" }}</td>
          <td>{{ student.LastName }}</td>
          <td>{{ student.MobileNo }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="onClose()">Close</button>
</div>
